import type { ReactNode } from "react";
import type { PageContext } from "vike/types";
import { CheckoutDrawer } from "@/components/CheckoutDrawer";
import { CookieConsent } from "@/components/CookieConsent";
import { WebChatBoot } from "@/components/WebChat/WebChatBoot";
import { CheckoutProvider } from "@/context/CheckoutContext";
import type { VikePageContext, VikePageContextServer } from "@/types/config";

export { PageShell };

interface PageShellProps {
  children: ReactNode;
  pageContext: PageContext | VikePageContext | VikePageContextServer;
}

function PageShell({ children, pageContext }: PageShellProps) {
  const pageName = (pageContext.pageProps as { pageName?: string } | undefined)?.pageName;

  return (
    <CheckoutProvider>
      {children}
      <CheckoutDrawer />
      <CookieConsent />
      <WebChatBoot pageName={pageName} />
    </CheckoutProvider>
  );
}
